import { Injectable, NgZone, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
    private readonly ngZone = inject(NgZone);
    public NoOfLoaderCount: any = 0;
    public isLoaderOn = new BehaviorSubject<boolean>(false);
 
    loadSpinner(status: boolean) {

        if (status) {
            this.NoOfLoaderCount++;
        } else {
            this.NoOfLoaderCount--;
        }
 
        if (this.NoOfLoaderCount == 1) {
            this.setLoaderState(true);
        } else if (this.NoOfLoaderCount <= 0) {
            this.NoOfLoaderCount = 0;
            this.setLoaderState(false);
        }

    }

    private setLoaderState(isLoading: boolean): void {
        this.ngZone.run(() => this.isLoaderOn.next(isLoading));
    }
}
